import React, { useState, useEffect, useRef } from "react";
import _ from "lodash";
import classNames from "classnames";
import { DropdownArrowUpIcon, DropdownArrowDownIcon } from "@netapp/bxp-design-system-react/icons/monochrome"
import style from "./TreeTableRow.module.scss";

const addLeftSpaceFn = (leftSpace) => ({
    "--leftSpace": `${leftSpace}px`,
});

export default function TreeTableRow({
    row,
    isRowSelectingEnabled,
    addLeftSpace = isRowSelectingEnabled ? 0 : 15,
    renderChildRow,
    index,
    childKey,
    expandFirstParentNode = false,
    expandAllNodes = false
}) {
    const [expand, setExpand] = useState(false);

    useEffect(() => {
            setExpand(expandAllNodes || expandFirstParentNode);
    }, [expandAllNodes, expandFirstParentNode]);
    
    return (
        <div style={addLeftSpaceFn(addLeftSpace)}>
            {!_.isEmpty(row[childKey]) ? (
                <>
                    <div
                        className={classNames(
                            style["table-row"],
                            isRowSelectingEnabled
                                ? style["tree-table-row-checkbox"]
                                : style["tree-table-row"],
                        )}
                        
                        onClick={() => {
                            setExpand((prevExp) => !prevExp);
                        }}
                    >
                        <span className={style["arrow-icon"]}>{expand ? <DropdownArrowUpIcon width={15}/> : <DropdownArrowDownIcon width={15}/>}</span>
                        {renderChildRow(row, index)}
                    </div>
                    <div>
                        {expand &&
                            _.map(row[childKey], (childRows, i) => {
                                return (
                                    <div key={i}>
                                        <TreeTableRow
                                            row={childRows}
                                            index={`${index}${i}`}
                                            renderChildRow={renderChildRow}
                                            addLeftSpace={addLeftSpace + 20}
                                            childKey={childKey}
                                            isRowSelectingEnabled={
                                                isRowSelectingEnabled
                                            }
                                            expandAllNodes={expandAllNodes}
                                        />
                                    </div>
                                );
                            })}
                    </div>
                </>
            ) : (
                <div
                    className={classNames(
                        isRowSelectingEnabled
                            ? style["tree-table-row-checkbox"]
                            : style["tree-table-row"],
                    )}
                >
                    {renderChildRow(row, index)}
                </div>
            )}
        </div>
    );
}
